// Libraries
import React from "react";
// Stylesheets
import '../../css/ErrorPage.css';
// Images
import logo from '../../img/brain-rain-logo.png';

const ErrorPage = () => {

  const getUrlWithoutRoute = () => {
    
    const locationParts = window.location.href.split('/');
    const domain = `http://${locationParts[2]}`;
    
    return domain === 'http://localhost:3000'
      ? domain
      : 'http://brain-rain.com';
  }

  return (
    <div id="error-wrapper">
      <img src={logo} alt="The BRAINRAIN logo." />
      <h1>Oops! Seems like you went the wrong way.</h1>
      <p>
        You can go back to the home page 👉&nbsp;
        <a href={getUrlWithoutRoute()}>
          this way
        </a>
        .
      </p>
    </div>
  );
};

export default ErrorPage;